var b = Object.defineProperty;
var g = (l, n, t) => n in l ? b(l, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : l[n] = t;
var o = (l, n, t) => (g(l, typeof n != "symbol" ? n + "" : n, t), t);
import { fabric as d } from "fabric";
import { outerBoxStyle as c } from "./index.es253.js";
import { GenericCalloutBox as f } from "./index.es170.js";
class S extends f {
  constructor(t) {
    super({ ...t, draggable: !0 });
    // TODO: because all our "factories" are not actually factories need this for calcScaleType
    // we need a better system - ie, factory should be a factory
    // Not a parent calloutbox type for each type of calloutbox
    // There should be one parent Calloutbox type
    o(this, "drawType", "Textbox");
    /* 
            TODO: get rid of this and refactor fabric objects
            current fabric design:
                "Factory" object -> "Specific Callout type" -> "More specific callout 2"
    
                ex: CalloutFactory   -> POICallout       -> Tenant/Thumbnail
                    RoadLabelFactory -> RoadLabelCallout -> RoadLabel
                    TextFactory      -> TextCallout
    
            what I think it should be:
                Factory Interface       -> General Callout type -> More specific callout type
    
                ex: CalloutInterface    -> CalloutBox           -> POICallout -> Tenant/Thumbnail
                                        -> CalloutBox           -> RoadLabel
                                        -> CalloutBox           -> Textbox
    
            fabric-overlay-control has several references to POICalloutBox types and only one current 
            "factory" creates this type and currently all updating 
            fabric functions only check for POICalloutBox types and its not really extendable without hacking
    
            A generic CalloutBox should take in options for:
                * hasLeaderLine
                * hasStatusOuterBox
                * hasSourcePoint
            
            and have a generic leaderLine, statusOuterBox, and sourcePoint that descendants can overwrite if necessary
            CalloutBox should handle all highlighting and generic light/dark styling and an extendable updateStyle function
            This then frees up the more specific descendants to only handle the specifics
    
            right now the logic for drawing/styling callout boxes is split too much and we should move logic onto one place
            so maintaining and updating any calloutbox type is easier
         */
    o(this, "renderedCalloutBox", {
      objType: "Textbox"
    });
    o(this, "container");
    o(this, "textbox");
    // controlled via props
    o(this, "textboxConfig");
    o(this, "poiInfo");
    o(this, "maxCalloutBoxWidth", 264);
    o(this, "minCalloutBoxHeight", 61);
    o(this, "PADDING", 16);
    this.textboxConfig = t.textboxConfig, this.poiInfo = {
      poiId: t.textboxConfig.poiId,
      geolocation: t.textboxConfig.geolocation
    };
  }
  updateStyleType(t) {
    var e;
    super.updateStyleType(t), (e = this.container) == null || e.set({
      ...c.idle.default,
      ...c.idle[t],
      ...c[this.status].default,
      ...c[this.status][t]
    });
  }
  syncCalloutBoxConfig(t) {
    var h, s;
    const e = this.container, i = this.textbox;
    if (e && t && (t.backgroundContainerColor && (e == null || e.set({ fill: t.backgroundContainerColor })), t.backgroundContainerOpacity && (e == null || e.set({
      opacity: t.backgroundContainerOpacity / 100
    })), t.textFontColor && (i == null || i.set({ fill: t.textFontColor })), t.textFontOpacity && (i == null || i.set({
      opacity: t.textFontOpacity / 100
    })), this.visible && "leaderLineVisible" in t)) {
      const a = !!t.leaderLineVisible;
      (h = this.sourcePoint) == null || h.set({
        visible: a
      }), (s = this.leaderLine) == null || s.set({
        visible: a
      });
    }
  }
  generateTextbox(t) {
    const { textFontColor: e, textFontFamily: i, textFontOpacity: h, textFontSize: s, textFontWeight: a } = this.textboxConfig.textboxStyleConfig, r = new d.Text(t, {
      fontFamily: i,
      fontWeight: a,
      fontSize: s
    }), x = (r == null ? void 0 : r.width) && this.maxCalloutBoxWidth < r.width, u = x ? this.maxCalloutBoxWidth : r.width;
    this.textbox = new d.Textbox(t, {
      width: u,
      fill: e,
      fontFamily: i,
      fontWeight: a,
      fontSize: s,
      opacity: h / 100,
      // if text has hit the limit, split the string
      ...x && { splitByGrapheme: !0 }
    });
  }
  async generate() {
    var e, i, h, s, a, r, x;
    this.generateTextbox(this.textboxConfig.text), this.container = new d.Rect({
      width: (((e = this.textbox) == null ? void 0 : e.width) || this.maxCalloutBoxWidth) + this.PADDING,
      height: (i = this.textbox) != null && i.height && this.minCalloutBoxHeight > ((h = this.textbox) == null ? void 0 : h.height) ? this.minCalloutBoxHeight : (((s = this.textbox) == null ? void 0 : s.height) || this.minCalloutBoxHeight) + this.PADDING,
      ...c.idle.default,
      ...c.idle[this.styleType],
      rx: this.textboxConfig.textboxStyleConfig.backgroundCornerRadius,
      ry: this.textboxConfig.textboxStyleConfig.backgroundCornerRadius
    }), (x = this.textbox) == null || x.set({
      left: (a = this.container) == null ? void 0 : a.getCenterPoint().x,
      top: (r = this.container) == null ? void 0 : r.getCenterPoint().y,
      originY: "center",
      originX: "center",
      textAlign: "center"
    });
    const t = new d.Group(
      [this.container, this.textbox].filter((u) => u)
    );
    this.addWithUpdate(t), this.scaleX = this.fabricObjScale, this.scaleY = this.fabricObjScale, this.updatePosition({ source: this.projectedXYSource }), this.updateStatus(this.status);
  }
}
export {
  S as Textbox
};
//# sourceMappingURL=index.es173.js.map
